import { combineReducers } from "redux";
import getCommercialReconciliationReducer from "./getCommercialReconciliationReducer";

const commercialReconciliationReducer = combineReducers({
    commercialReconciliation: getCommercialReconciliationReducer
});

export default commercialReconciliationReducer;